import React from "react";

export function Logo({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="relative w-8 h-8 rounded-lg bg-gradient-to-br from-el-400 to-el-700 flex items-center justify-center shadow-surface">
        <svg viewBox="0 0 24 24" className="w-5 h-5 text-white" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 19 L9 11 L13 16 L19 5" />
          <circle cx="9" cy="11" r="1.4" fill="currentColor" />
          <circle cx="13" cy="16" r="1.4" fill="currentColor" />
          <circle cx="19" cy="5"  r="1.4" fill="currentColor" />
        </svg>
      </div>
      <div className="leading-tight">
        <div className="text-[1.05rem] font-semibold text-slate-900 tracking-tightish">Eleetz</div>
        <div className="text-[0.65rem] uppercase tracking-[0.12em] text-el-700 font-semibold">Movement</div>
      </div>
    </div>
  );
}
